import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

const SalesChart = ({ data }) => {
  // Process the actual data from the API
  const processOrdersData = () => {
    if (!data || !Array.isArray(data)) {
      return [];
    }

    // Group orders by date and calculate total sales for each date
    const salesByDate = {};
    
    data.forEach(order => {
      if (order.createdAt) {
        const date = format(new Date(order.createdAt), 'MMM dd');
        if (!salesByDate[date]) {
          salesByDate[date] = 0;
        }
        salesByDate[date] += order.totalPrice || 0;
      }
    });

    // Convert to array format for the chart
    return Object.entries(salesByDate).map(([date, sales]) => ({
      date,
      sales
    })).sort((a, b) => {
      // Sort by date
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA - dateB;
    });
  };

  const chartData = processOrdersData();

  // If no data is available, show a message
  if (chartData.length === 0) {
    return <div className="text-center py-10">No sales data available for the selected period.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <XAxis dataKey="date" />
        <YAxis />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip formatter={(value) => [`£${value.toFixed(2)}`, 'Sales']} />
        <Area 
          type="monotone" 
          dataKey="sales" 
          stroke="#8884d8" 
          fillOpacity={1} 
          fill="url(#colorSales)" 
          name="Sales"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default SalesChart;
